
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $f04f93e6bce7a67b$exports = {};
!function(t, n) {
    $f04f93e6bce7a67b$exports = n();
}("undefined" != typeof self ? self : $f04f93e6bce7a67b$exports, function() {
    return function() {
        "use strict";
        var t = {
            407: function(t, n, e) {
                e.d(n, {
                    default: function() {
                        return N;
                    }
                });
                var o = /([:*])(\w+)/g, r = /\*/g, i = /\/\?/g;
                function a(t) {
                    return void 0 === t && (t = "/"), v() ? location.pathname + location.search + location.hash : t;
                }
                function s(t) {
                    return t.replace(/\/+$/, "").replace(/^\/+/, "");
                }
                function c(t) {
                    return "string" == typeof t;
                }
                function u(t) {
                    return t && t.indexOf("#") >= 0 && t.split("#").pop() || "";
                }
                function h(t) {
                    var n = s(t).split(/\?(.*)?$/);
                    return [
                        s(n[0]),
                        n.slice(1).join("")
                    ];
                }
                function f(t) {
                    for(var n = {}, e = t.split("&"), o = 0; o < e.length; o++){
                        var r = e[o].split("=");
                        if ("" !== r[0]) {
                            var i = decodeURIComponent(r[0]);
                            n[i] ? (Array.isArray(n[i]) || (n[i] = [
                                n[i]
                            ]), n[i].push(decodeURIComponent(r[1] || ""))) : n[i] = decodeURIComponent(r[1] || "");
                        }
                    }
                    return n;
                }
                function l(t, n) {
                    var e, a = h(s(t.currentLocationPath)), l = a[0], p = a[1], d = "" === p ? null : f(p), v = [];
                    if (c(n.path)) {
                        if (e = "(?:/^|^)" + s(n.path).replace(o, function(t, n, e) {
                            return v.push(e), "([^/]+)";
                        }).replace(r, "?(?:.*)").replace(i, "/?([^/]+|)") + "$", "" === s(n.path) && "" === s(l)) return {
                            url: l,
                            queryString: p,
                            hashString: u(t.to),
                            route: n,
                            data: null,
                            params: d
                        };
                    } else e = n.path;
                    var g = new RegExp(e, ""), m = l.match(g);
                    if (m) {
                        var y = c(n.path) ? function(t, n) {
                            return 0 === n.length ? null : t ? t.slice(1, t.length).reduce(function(t, e, o) {
                                return null === t && (t = {}), t[n[o]] = decodeURIComponent(e), t;
                            }, null) : null;
                        }(m, v) : m.groups ? m.groups : m.slice(1);
                        return {
                            url: s(l.replace(new RegExp("^" + t.instance.root), "")),
                            queryString: p,
                            hashString: u(t.to),
                            route: n,
                            data: y,
                            params: d
                        };
                    }
                    return !1;
                }
                function p() {
                    return !("undefined" == typeof window || !window.history || !window.history.pushState);
                }
                function d(t, n) {
                    return void 0 === t[n] || !0 === t[n];
                }
                function v() {
                    return "undefined" != typeof window;
                }
                function g(t, n) {
                    return void 0 === t && (t = []), void 0 === n && (n = {}), t.filter(function(t) {
                        return t;
                    }).forEach(function(t) {
                        [
                            "before",
                            "after",
                            "already",
                            "leave"
                        ].forEach(function(e) {
                            t[e] && (n[e] || (n[e] = []), n[e].push(t[e]));
                        });
                    }), n;
                }
                function m(t, n, e) {
                    var o = n || {}, r = 0;
                    !function n() {
                        t[r] ? Array.isArray(t[r]) ? (t.splice.apply(t, [
                            r,
                            1
                        ].concat(t[r][0](o) ? t[r][1] : t[r][2])), n()) : t[r](o, function(t) {
                            void 0 === t || !0 === t ? (r += 1, n()) : e && e(o);
                        }) : e && e(o);
                    }();
                }
                function y(t, n) {
                    void 0 === t.currentLocationPath && (t.currentLocationPath = t.to = a(t.instance.root)), t.currentLocationPath = t.instance._checkForAHash(t.currentLocationPath), n();
                }
                function _(t, n) {
                    for(var e = 0; e < t.instance.routes.length; e++){
                        var o = l(t, t.instance.routes[e]);
                        if (o && (t.matches || (t.matches = []), t.matches.push(o), "ONE" === t.resolveOptions.strategy)) return void n();
                    }
                    n();
                }
                function k(t, n) {
                    t.navigateOptions && (void 0 !== t.navigateOptions.shouldResolve && console.warn('"shouldResolve" is deprecated. Please check the documentation.'), void 0 !== t.navigateOptions.silent && console.warn('"silent" is deprecated. Please check the documentation.')), n();
                }
                function O(t, n) {
                    !0 === t.navigateOptions.force ? (t.instance._setCurrent([
                        t.instance._pathToMatchObject(t.to)
                    ]), n(!1)) : n();
                }
                m.if = function(t, n, e) {
                    return Array.isArray(n) || (n = [
                        n
                    ]), Array.isArray(e) || (e = [
                        e
                    ]), [
                        t,
                        n,
                        e
                    ];
                };
                var w = v(), L = p();
                function b(t, n) {
                    if (d(t.navigateOptions, "updateBrowserURL")) {
                        var e = ("/" + t.to).replace(/\/\//g, "/"), o = w && t.resolveOptions && !0 === t.resolveOptions.hash;
                        L ? (history[t.navigateOptions.historyAPIMethod || "pushState"](t.navigateOptions.stateObj || {}, t.navigateOptions.title || "", o ? "#" + e : e), location && location.hash && (t.instance.__freezeListening = !0, setTimeout(function() {
                            if (!o) {
                                var n = location.hash;
                                location.hash = "", location.hash = n;
                            }
                            t.instance.__freezeListening = !1;
                        }, 1))) : w && (window.location.href = t.to);
                    }
                    n();
                }
                function A(t, n) {
                    var e = t.instance;
                    e.lastResolved() ? m(e.lastResolved().map(function(n) {
                        return function(e, o) {
                            if (n.route.hooks && n.route.hooks.leave) {
                                var r = !1, i = t.instance.matchLocation(n.route.path, t.currentLocationPath, !1);
                                r = "*" !== n.route.path ? !i : !(t.matches && t.matches.find(function(t) {
                                    return n.route.path === t.route.path;
                                })), d(t.navigateOptions, "callHooks") && r ? m(n.route.hooks.leave.map(function(n) {
                                    return function(e, o) {
                                        return n(function(n) {
                                            !1 === n ? t.instance.__markAsClean(t) : o();
                                        }, t.matches && t.matches.length > 0 ? 1 === t.matches.length ? t.matches[0] : t.matches : void 0);
                                    };
                                }).concat([
                                    function() {
                                        return o();
                                    }
                                ])) : o();
                            } else o();
                        };
                    }), {}, function() {
                        return n();
                    }) : n();
                }
                function P(t, n) {
                    d(t.navigateOptions, "updateState") && t.instance._setCurrent(t.matches), n();
                }
                var R = [
                    function(t, n) {
                        var e = t.instance.lastResolved();
                        if (e && e[0] && e[0].route === t.match.route && e[0].url === t.match.url && e[0].queryString === t.match.queryString) return e.forEach(function(n) {
                            n.route.hooks && n.route.hooks.already && d(t.navigateOptions, "callHooks") && n.route.hooks.already.forEach(function(n) {
                                return n(t.match);
                            });
                        }), void n(!1);
                        n();
                    },
                    function(t, n) {
                        t.match.route.hooks && t.match.route.hooks.before && d(t.navigateOptions, "callHooks") ? m(t.match.route.hooks.before.map(function(n) {
                            return function(e, o) {
                                return n(function(n) {
                                    !1 === n ? t.instance.__markAsClean(t) : o();
                                }, t.match);
                            };
                        }).concat([
                            function() {
                                return n();
                            }
                        ])) : n();
                    },
                    function(t, n) {
                        d(t.navigateOptions, "callHandler") && t.match.route.handler(t.match), t.instance.updatePageLinks(), n();
                    },
                    function(t, n) {
                        t.match.route.hooks && t.match.route.hooks.after && d(t.navigateOptions, "callHooks") && t.match.route.hooks.after.forEach(function(n) {
                            return n(t.match);
                        }), n();
                    }
                ], S = [
                    A,
                    function(t, n) {
                        var e = t.instance._notFoundRoute;
                        if (e) {
                            t.notFoundHandled = !0;
                            var o = h(t.currentLocationPath), r = o[0], i = o[1], a = u(t.to);
                            e.path = s(r);
                            var c = {
                                url: e.path,
                                queryString: i,
                                hashString: a,
                                data: null,
                                route: e,
                                params: "" !== i ? f(i) : null
                            };
                            t.matches = [
                                c
                            ], t.match = c;
                        }
                        n();
                    },
                    m.if(function(t) {
                        return t.notFoundHandled;
                    }, R.concat([
                        P
                    ]), [
                        function(t, n) {
                            t.resolveOptions && !1 !== t.resolveOptions.noMatchWarning && void 0 !== t.resolveOptions.noMatchWarning || console.warn('Navigo: "' + t.currentLocationPath + "\" didn't match any of the registered routes."), n();
                        },
                        function(t, n) {
                            t.instance._setCurrent(null), n();
                        }
                    ])
                ];
                function E() {
                    return (E = Object.assign || function(t) {
                        for(var n = 1; n < arguments.length; n++){
                            var e = arguments[n];
                            for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        }
                        return t;
                    }).apply(this, arguments);
                }
                function x(t, n) {
                    var e = 0;
                    A(t, function o() {
                        e !== t.matches.length ? m(R, E({}, t, {
                            match: t.matches[e]
                        }), function() {
                            e += 1, o();
                        }) : P(t, n);
                    });
                }
                function H(t) {
                    t.instance.__markAsClean(t);
                }
                function j() {
                    return (j = Object.assign || function(t) {
                        for(var n = 1; n < arguments.length; n++){
                            var e = arguments[n];
                            for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
                        }
                        return t;
                    }).apply(this, arguments);
                }
                var C = "[data-navigo]";
                function N(t, n) {
                    var e, o = n || {
                        strategy: "ONE",
                        hash: !1,
                        noMatchWarning: !1,
                        linksSelector: C
                    }, r = this, i = "/", d = null, w = [], L = !1, A = p(), P = v();
                    function R(t) {
                        return t.indexOf("#") >= 0 && (t = !0 === o.hash ? t.split("#")[1] || "/" : t.split("#")[0]), t;
                    }
                    function E(t) {
                        return s(i + "/" + s(t));
                    }
                    function N(t, n, e, o) {
                        return t = c(t) ? E(t) : t, {
                            name: o || s(String(t)),
                            path: t,
                            handler: n,
                            hooks: g(e)
                        };
                    }
                    function U(t, n) {
                        if (!r.__dirty) {
                            r.__dirty = !0, t = t ? s(i) + "/" + s(t) : void 0;
                            var e = {
                                instance: r,
                                to: t,
                                currentLocationPath: t,
                                navigateOptions: {},
                                resolveOptions: j({}, o, n)
                            };
                            return m([
                                y,
                                _,
                                m.if(function(t) {
                                    var n = t.matches;
                                    return n && n.length > 0;
                                }, x, S)
                            ], e, H), !!e.matches && e.matches;
                        }
                        r.__waiting.push(function() {
                            return r.resolve(t, n);
                        });
                    }
                    function q(t, n) {
                        if (r.__dirty) r.__waiting.push(function() {
                            return r.navigate(t, n);
                        });
                        else {
                            r.__dirty = !0, t = s(i) + "/" + s(t);
                            var e = {
                                instance: r,
                                to: t,
                                navigateOptions: n || {},
                                resolveOptions: n && n.resolveOptions ? n.resolveOptions : o,
                                currentLocationPath: R(t)
                            };
                            m([
                                k,
                                O,
                                _,
                                m.if(function(t) {
                                    var n = t.matches;
                                    return n && n.length > 0;
                                }, x, S),
                                b,
                                H
                            ], e, H);
                        }
                    }
                    function F() {
                        if (P) return (P ? [].slice.call(document.querySelectorAll(o.linksSelector || C)) : []).forEach(function(t) {
                            "false" !== t.getAttribute("data-navigo") && "_blank" !== t.getAttribute("target") ? t.hasListenerAttached || (t.hasListenerAttached = !0, t.navigoHandler = function(n) {
                                if ((n.ctrlKey || n.metaKey) && "a" === n.target.tagName.toLowerCase()) return !1;
                                var e = t.getAttribute("href");
                                if (null == e) return !1;
                                if (e.match(/^(http|https)/) && "undefined" != typeof URL) try {
                                    var o = new URL(e);
                                    e = o.pathname + o.search;
                                } catch (t) {}
                                var i = function(t) {
                                    if (!t) return {};
                                    var n, e = t.split(","), o = {};
                                    return e.forEach(function(t) {
                                        var e = t.split(":").map(function(t) {
                                            return t.replace(/(^ +| +$)/g, "");
                                        });
                                        switch(e[0]){
                                            case "historyAPIMethod":
                                                o.historyAPIMethod = e[1];
                                                break;
                                            case "resolveOptionsStrategy":
                                                n || (n = {}), n.strategy = e[1];
                                                break;
                                            case "resolveOptionsHash":
                                                n || (n = {}), n.hash = "true" === e[1];
                                                break;
                                            case "updateBrowserURL":
                                            case "callHandler":
                                            case "updateState":
                                            case "force":
                                                o[e[0]] = "true" === e[1];
                                        }
                                    }), n && (o.resolveOptions = n), o;
                                }(t.getAttribute("data-navigo-options"));
                                L || (n.preventDefault(), n.stopPropagation(), r.navigate(s(e), i));
                            }, t.addEventListener("click", t.navigoHandler)) : t.hasListenerAttached && t.removeEventListener("click", t.navigoHandler);
                        }), r;
                    }
                    function I(t, n, e) {
                        var o = w.find(function(n) {
                            return n.name === t;
                        }), r = null;
                        if (o) {
                            if (r = o.path, n) for(var a in n)r = r.replace(":" + a, n[a]);
                            r = r.match(/^\//) ? r : "/" + r;
                        }
                        return r && e && !e.includeRoot && (r = r.replace(new RegExp("^/" + i), "")), r;
                    }
                    function M(t) {
                        var n = h(s(t)), o = n[0], r = n[1], i = "" === r ? null : f(r);
                        return {
                            url: o,
                            queryString: r,
                            hashString: u(t),
                            route: N(o, function() {}, [
                                e
                            ], o),
                            data: null,
                            params: i
                        };
                    }
                    function T(t, n, e) {
                        return "string" == typeof n && (n = z(n)), n ? (n.hooks[t] || (n.hooks[t] = []), n.hooks[t].push(e), function() {
                            n.hooks[t] = n.hooks[t].filter(function(t) {
                                return t !== e;
                            });
                        }) : (console.warn("Route doesn't exists: " + n), function() {});
                    }
                    function z(t) {
                        return "string" == typeof t ? w.find(function(n) {
                            return n.name === E(t);
                        }) : w.find(function(n) {
                            return n.handler === t;
                        });
                    }
                    t ? i = s(t) : console.warn('Navigo requires a root path in its constructor. If not provided will use "/" as default.'), this.root = i, this.routes = w, this.destroyed = L, this.current = d, this.__freezeListening = !1, this.__waiting = [], this.__dirty = !1, this.__markAsClean = function(t) {
                        t.instance.__dirty = !1, t.instance.__waiting.length > 0 && t.instance.__waiting.shift()();
                    }, this.on = function(t, n, o) {
                        var r = this;
                        return "object" != typeof t || t instanceof RegExp ? ("function" == typeof t && (o = n, n = t, t = i), w.push(N(t, n, [
                            e,
                            o
                        ])), this) : (Object.keys(t).forEach(function(n) {
                            if ("function" == typeof t[n]) r.on(n, t[n]);
                            else {
                                var o = t[n], i = o.uses, a = o.as, s = o.hooks;
                                w.push(N(n, i, [
                                    e,
                                    s
                                ], a));
                            }
                        }), this);
                    }, this.off = function(t) {
                        return this.routes = w = w.filter(function(n) {
                            return c(t) ? s(n.path) !== s(t) : "function" == typeof t ? t !== n.handler : String(n.path) !== String(t);
                        }), this;
                    }, this.resolve = U, this.navigate = q, this.navigateByName = function(t, n, e) {
                        var o = I(t, n);
                        return null !== o && (q(o.replace(new RegExp("^/?" + i), ""), e), !0);
                    }, this.destroy = function() {
                        this.routes = w = [], A && window.removeEventListener("popstate", this.__popstateListener), this.destroyed = L = !0;
                    }, this.notFound = function(t, n) {
                        return r._notFoundRoute = N("*", t, [
                            e,
                            n
                        ], "__NOT_FOUND__"), this;
                    }, this.updatePageLinks = F, this.link = function(t) {
                        return "/" + i + "/" + s(t);
                    }, this.hooks = function(t) {
                        return e = t, this;
                    }, this.extractGETParameters = function(t) {
                        return h(R(t));
                    }, this.lastResolved = function() {
                        return d;
                    }, this.generate = I, this.getLinkPath = function(t) {
                        return t.getAttribute("href");
                    }, this.match = function(t) {
                        var n = {
                            instance: r,
                            currentLocationPath: t,
                            to: t,
                            navigateOptions: {},
                            resolveOptions: o
                        };
                        return _(n, function() {}), !!n.matches && n.matches;
                    }, this.matchLocation = function(t, n, e) {
                        void 0 === n || void 0 !== e && !e || (n = E(n));
                        var o = {
                            instance: r,
                            to: n,
                            currentLocationPath: n
                        };
                        return y(o, function() {}), "string" == typeof t && (t = void 0 === e || e ? E(t) : t), l(o, {
                            name: String(t),
                            path: t,
                            handler: function() {},
                            hooks: {}
                        }) || !1;
                    }, this.getCurrentLocation = function() {
                        return M(s(a(i)).replace(new RegExp("^" + i), ""));
                    }, this.addBeforeHook = T.bind(this, "before"), this.addAfterHook = T.bind(this, "after"), this.addAlreadyHook = T.bind(this, "already"), this.addLeaveHook = T.bind(this, "leave"), this.getRoute = z, this._pathToMatchObject = M, this._clean = s, this._checkForAHash = R, this._setCurrent = function(t) {
                        return d = r.current = t;
                    }, (function() {
                        A && (this.__popstateListener = function() {
                            r.__freezeListening || U();
                        }, window.addEventListener("popstate", this.__popstateListener));
                    }).call(this), F.call(this);
                }
            }
        }, n = {};
        function e(o) {
            if (n[o]) return n[o].exports;
            var r = n[o] = {
                exports: {}
            };
            return t[o](r, r.exports, e), r.exports;
        }
        return e.d = function(t, n) {
            for(var o in n)e.o(n, o) && !e.o(t, o) && Object.defineProperty(t, o, {
                enumerable: !0,
                get: n[o]
            });
        }, e.o = function(t, n) {
            return Object.prototype.hasOwnProperty.call(t, n);
        }, e(407);
    }().default;
});


/* eslint-disable import/no-unresolved */ var $fbc2b18346c73c7c$exports = {};
$fbc2b18346c73c7c$exports = "<div class=\"container\" id=\"main-container\"> <form id=\"form\" novalidate> <input type=\"hidden\" name=\"charge\" id=\"charge\" value=\"0\"> <input type=\"hidden\" name=\"total\" id=\"total\" value=\"0\"> <input type=\"hidden\" name=\"nonce\" id=\"card-nonce\"> <input type=\"hidden\" name=\"recaptcha_token\" id=\"recaptcha-token\"> <h1>Booking Form</h1> <div id=\"steps\"></div> <div id=\"recaptcha\"></div> </form> </div>";


var $310e8bee6db8d9d5$exports = {};
$310e8bee6db8d9d5$exports = "<fieldset id=\"step-1\"> <legend>Step 1: Service Selection</legend> <div class=\"row\"> <div class=\"col-md-4 col-sm-12\"> <label for=\"service-required\" class=\"form-label\">What Would You Like? <span class=\"text-danger\">*</span></label> </div> <div class=\"col-md-8 col-sm-12 mb-3\"> <select name=\"service_required\" id=\"service-required\" class=\"form-select\" required> <option value>Please Select</option> <option value=\"Garden Bags\">Garden Bags</option> <option value=\"Garden Bins\">Garden Bins</option> </select> <div class=\"invalid-feedback\">Field is required</div> </div> </div> <div class=\"row\"> <div class=\"col-md-4 col-sm-12\"> <label for=\"delivery-option\" class=\"form-label\">Select A Pickup Option <span class=\"text-danger\">*</span></label> </div> <div class=\"col-md-8 col-sm-12 mb-3\"> <select name=\"delivery_option\" id=\"delivery-option\" class=\"form-select\" required> <option value>Please Select</option> <option value=\"one-off\" id=\"one-off\">One-off Service</option> <option value=\"monthly\"> Monthly - Every 4 Weeks (min service 3 pickups) </option> <option value=\"bi-monthly\"> Bi-monthly - Every 8 Weeks (min service 3 pickups) </option> <option value=\"quarterly\"> Quarterly - Every 3 Months (min service 3 pickups) </option> </select> <div class=\"invalid-feedback\">Field is required</div> </div> </div> <div class=\"row\"> <div class=\"col-md-4 col-sm-12\"> <label for=\"payment-option\" class=\"form-label\">Select A Payment Option <span class=\"text-danger\">*</span></label> </div> <div class=\"col-md-8 col-sm-12 mb-3\"> <select name=\"payment_option\" id=\"payment-option\" class=\"form-select\" required> <option value>Please Select</option> </select> <div class=\"invalid-feedback\">Field is required</div> </div> </div> <div class=\"row\" id=\"bins-bags-row\"> <div class=\"col-md-4 col-sm-12\"> <label for=\"number-bins-bags\" class=\"form-label\">Select Number of Bins/Bags <span class=\"text-danger\">*</span></label> </div> <div class=\"col-md-8 col-sm-12 mb-3\"> <select name=\"number_bins_bags\" id=\"number-bins-bags\" class=\"form-select\" required> <option value>Please Select</option> <option value=\"1\">1</option> <option value=\"2\">2</option> <option value=\"3\">3</option> <option value=\"4\">4</option> <option value=\"5\">5</option> <option value=\"6\">6</option> <option value=\"7\">7</option> <option value=\"8\">8</option> <option value=\"9\">9</option> <option value=\"10\">10</option> <option value=\"11\">11</option> <option value=\"12\">12</option> <option value=\"13\">13</option> <option value=\"14\">14</option> <option value=\"15\">15</option> <option value=\"16\">16</option> <option value=\"17\">17</option> <option value=\"18\">18</option> <option value=\"19\">19</option> <option value=\"20\">20</option> </select> <div class=\"invalid-feedback\">Field is required</div> <em class=\"form-text\" id=\"additional-bag\" style=\"display:none\">(Additional Bins/Bags charged at $<span id=\"additional-bag-fee\"></span> each. 1 Included in Order)</em> </div> </div> <div class=\"text-end\"> <a href=\"/step-2\" class=\"btn btn-lg btn-secondary\" data-current=\"1\" data-step=\"next\">Next</a> </div> </fieldset>";


var $cf51765c5de856cf$exports = {};
$cf51765c5de856cf$exports = "<fieldset id=\"step-2\"> <legend>Step 2: Delivery Details</legend> <div class=\"row\"> <div class=\"col-md-6 col-sm-12 mb-3\"> <label for=\"region\" class=\"form-label\">Region <span class=\"text-danger\">*</span></label> <select name=\"region\" id=\"region\" class=\"form-select\" required> <option value>Please Select</option> <option value=\"Brisbane\">Brisbane</option> <option value=\"Gold Coast\">Gold Coast</option> <option value=\"Ipswich\">Ipswich</option> </select> <div class=\"invalid-feedback\">Field is required</div> </div> <div class=\"col-md-6 col-sm-12 mb-3\"> <label for=\"suburb\" class=\"form-label\">Suburb <span class=\"text-danger\">*</span></label> <select name=\"suburb\" id=\"suburb\" class=\"form-select\" required> <option value>Please Select</option> </select> <div class=\"invalid-feedback\">Field is required</div> </div> </div> <div class=\"row\"> <div class=\"col-md-6 col-sm-12 mb-3\"> <label for=\"address-type\" class=\"form-label\">Deliver To <span class=\"text-danger\">*</span></label> <select name=\"address_type\" id=\"address-type\" class=\"form-select\" required> <option value>Please Select</option> <option value=\"My Residence\">My Residence</option> <option value=\"Investment Property\">Investment Property</option> <option value=\"Business Premises\">Business Premises</option> </select> <div class=\"invalid-feedback\">Field is required</div> </div> <div class=\"col-md-6 col-sm-12 mb-3\"> <label for=\"address\" class=\"form-label\">Address <span class=\"text-danger\">*</span></label> <input type=\"text\" name=\"address\" id=\"address\" class=\"form-control\" required> <div class=\"invalid-feedback\">Field is required</div> </div> </div> <div class=\"row\" id=\"tenant-details-row\" style=\"display:none\"> <div class=\"col-md-6 col-sm-12 mb-3\"> <label for=\"tenant-name\" class=\"form-label\">Tenant's Name</label> <input type=\"text\" name=\"tenant_name\" id=\"tenant-name\" class=\"form-control\"> </div> <div class=\"col-md-6 col-sm-12 mb-3\"> <label for=\"tenant-phone\" class=\"form-label\">Tenant's Phone</label> <input type=\"text\" name=\"tenant_phone\" id=\"tenant-phone\" class=\"form-control\" pattern=\"^0(?:4|7)\\d{8}$\"> <div class=\"invalid-feedback\"> Please enter a valid phone number, e.g. 0410123456, 0712345678 </div> </div> </div> <div class=\"row\" id=\"business-name-row\" style=\"display:none\"> <div class=\"col-sm-12 mb-3\"> <label for=\"business-name\" class=\"form-label\">Business Name <em>(If Applicable)</em></label> <input type=\"text\" name=\"business_name\" id=\"business-name\" class=\"form-control\"> </div> </div> <div class=\"row\"> <div class=\"col-md-12 col-sm-12 mb-3\"> <label for=\"invoice-address\" class=\"form-label\">Invoice Address <em>(If different to delivery address)</em></label> <textarea name=\"invoice_address\" id=\"invoice-address\" class=\"form-control\"></textarea> </div> </div> <div class=\"row\"> <div class=\"col-md-12 col-sm-12 mb-3\"> <label for=\"special-instructions\" class=\"form-label\">Special Instructions</label> <textarea name=\"special_instructions\" id=\"special-instructions\" class=\"form-control\" placeholder=\"Locked gates, dogs in yard, gate code required, bag behind carport etc...\"></textarea> </div> </div> <div class=\"row\"> <div class=\"col-6\"> <a href=\"/\" class=\"btn btn-lg btn-secondary\" data-current=\"2\" data-step=\"prev\">Prev</a> </div> <div class=\"col-6 text-end\"> <a href=\"/step-3\" class=\"btn btn-lg btn-secondary\" data-current=\"2\" data-step=\"next\">Next</a> </div> </div> </fieldset>";


var $0dadd6f7d90f42aa$exports = {};
$0dadd6f7d90f42aa$exports = "<fieldset id=\"step-3\"> <legend>Step 3: Contact Details</legend> <div class=\"row\"> <div class=\"col-md-6 col-sm-12 mb-3\"> <label for=\"full-name\" class=\"form-label\">Your Full Name <span class=\"text-danger\">*</span></label> <input type=\"text\" name=\"full_name\" id=\"full-name\" class=\"form-control\" required pattern=\"^\\w+ \\w+.*\"> <div class=\"invalid-feedback\"> You must provide both first name and last name </div> </div> <div class=\"col-md-6 col-sm-12 mb-3\"> <label for=\"email\" class=\"form-label\">Email Address <span class=\"text-danger\">*</span></label> <input type=\"email\" name=\"email\" id=\"email\" class=\"form-control\" required> <div class=\"invalid-feedback\">Valid email is required</div> </div> </div> <div class=\"row\"> <div class=\"col-md-6 col-sm-12 mb-3\"> <label for=\"mobile\" class=\"form-label\">Mobile <span class=\"text-danger\">*</span></label> <input type=\"text\" name=\"mobile\" id=\"mobile\" class=\"form-control\" required pattern=\"^0(?:4|7)\\d{8}$\"> <div class=\"invalid-feedback\"> A valid phone number is required, e.g. 0410123456, 0712345678 </div> </div> <div class=\"col-md-6 col-sm-12 mb-3\"> <label for=\"home-phone\" class=\"form-label\">Home Phone</label> <input type=\"text\" name=\"home_phone\" id=\"home-phone\" class=\"form-control\" pattern=\"^0(?:4|7)\\d{8}$\"> <div class=\"invalid-feedback\"> Please enter a valid phone number, e.g. 0410123456, 0712345678 </div> </div> </div> <div class=\"row\"> <div class=\"col-md-6 col-sm-12 mb-3\"> <label for=\"work-phone\" class=\"form-label\">Work Phone</label> <input type=\"text\" name=\"work_phone\" id=\"work-phone\" class=\"form-control\" pattern=\"^0(?:4|7)\\d{8}$\"> <div class=\"invalid-feedback\"> Please enter a valid phone number, e.g. 0410123456, 0712345678 </div> </div> <div class=\"col-md-6 col-sm-12 mb-3\"> <label for=\"preferred-no\" class=\"form-label\">Preferred No.</label> <select name=\"preferred_no\" id=\"preferred-no\" class=\"form-select\"> <option value>Please Select</option> <option value=\"Home Phone\">Home Phone</option> <option value=\"Work Phone\">Work Phone</option> <option value=\"Mobile\" selected>Mobile</option> </select> </div> </div> <div class=\"row\"> <div class=\"col-md-6 col-sm-12 mb-3\"> <label for=\"property-tenanted\" class=\"form-label\">Is this Property Tenanted?</label> <select name=\"property_tenanted\" id=\"property-tenanted\" class=\"form-select\"> <option value>Please Select</option> <option value=\"No, I own this property\"> No, I own this property </option> <option value=\"Yes, I am the tenant\"> Yes, I am the tenant </option> <option value=\"Yes, I am the landlord/property manager\"> Yes, I am the landlord/property manager </option> </select> </div> <div class=\"col-md-6 col-sm-12 mb-3\" id=\"landlord-name-cell\" style=\"display:none\"> <label for=\"landlord-name\" class=\"form-label\">Landlord/Property Manager Name <span class=\"text-danger\">*</span></label> <input type=\"text\" name=\"landlord_name\" id=\"landlord-name\" class=\"form-control\"> <div class=\"invalid-feedback\">Field is required</div> </div> </div> <div class=\"row\" id=\"agency-details-row\" style=\"display:none\"> <div class=\"col-md-6 col-sm-12 mb-3\"> <label for=\"agency-name\" class=\"form-label\">Agency Name <span class=\"text-danger\">*</span></label> <input type=\"text\" name=\"agency_name\" id=\"agency-name\" class=\"form-control\"> <div class=\"invalid-feedback\">Field is required</div> </div> <div class=\"col-md-6 col-sm-12 mb-3\"> <label for=\"agency-phone\" class=\"form-label\">Agency Phone <span class=\"text-danger\">*</span></label> <input type=\"text\" name=\"agency_phone\" id=\"agency-phone\" class=\"form-control\" pattern=\"^0(?:4|7)\\d{8}$\"> <div class=\"invalid-feedback\"> A valid phone number is required, e.g. 0410123456, 0712345678 </div> </div> </div> <div class=\"row\"> <div class=\"col-6\"> <a href=\"/step-2\" class=\"btn btn-lg btn-secondary\" data-current=\"3\" data-step=\"prev\">Prev</a> </div> <div class=\"col-6 text-end\"> <a href=\"/step-4\" class=\"btn btn-lg btn-secondary\" data-current=\"3\" data-step=\"next\">Next</a> </div> </div> </fieldset>";


var $cf169d5cf45be00f$exports = {};
$cf169d5cf45be00f$exports = "<fieldset id=\"step-4\"> <legend>Step 4: Payment Details</legend> <div class=\"row\"> <div class=\"col-md-6 col-sm-12 mb-3\"> <p>How Would You Like to Pay? <span class=\"text-danger\">*</span></p> <div class=\"form-check\"> <input class=\"form-check-input\" type=\"radio\" name=\"payment_method\" id=\"payment-method-1\" value=\"Direct Deposit\" required> <label class=\"form-check-label\" for=\"payment-method-1\"> Direct Deposit </label> </div> <div class=\"form-check\"> <input class=\"form-check-input\" type=\"radio\" name=\"payment_method\" id=\"payment-method-3\" value=\"Credit Card\" required> <label class=\"form-check-label\" for=\"payment-method-3\"> Credit Card </label> </div> <div class=\"invalid-feedback\">Field is required</div> </div> </div> <div class=\"row\" id=\"card-details\" style=\"display:none\"> <div class=\"col-md-8 col-sm-12 mb-3\"> <div id=\"card-dropin\"></div> </div> </div> <div class=\"row\"> <div class=\"col-sm-12 mb-3\"> <div class=\"form-check\"> <input type=\"checkbox\" name=\"agree_terms\" id=\"agree-terms\" class=\"form-check-input\" value=\"Yes\" required> <label for=\"agree-terms\" class=\"form-check-label\">I agree to the <a href=\"https://gardenbagsbrisbane.com.au/terms-conditions-garden-bags/\" target=\"_blank\">Terms &amp; Conditions</a></label> <div class=\"invalid-feedback\"> You must agree to the terms and conditions </div> </div> </div> </div> <div class=\"alert alert-info\" role=\"alert\"> <ul> <li>Total: $<span id=\"info-total\">0</span> <em>inc GST</em></li> </ul> </div> <div class=\"alert alert-info\" role=\"alert\" id=\"direct-deposit-info\" style=\"display:none\"> <p><strong>Please transfer full amount to:</strong></p> <ul> <li>Account: Ecoclear Waste and Recycling</li> <li>BSB: 084-961</li> <li>A/C No: 881968563</li> </ul> </div> <div class=\"alert alert-success\" role=\"alert\" id=\"success-alert\" style=\"display:none\"> <p><strong>Success</strong></p> <span id=\"success-message\"></span> </div> <div class=\"alert alert-danger\" role=\"alert\" id=\"error-alert\" style=\"display:none\"> <p><strong>Error</strong></p> <span id=\"error-message\"></span> </div> <div class=\"row\"> <div class=\"col-6\"> <a href=\"/step-3\" class=\"btn btn-lg btn-secondary\" data-current=\"4\" data-step=\"prev\">Prev</a> </div> <div class=\"col-6 text-end\"> <a href=\"/submit\" class=\"btn btn-lg btn-secondary\" data-current=\"4\" data-step=\"next\"><i class=\"fa-cog fas\" id=\"submit-cog\"></i> Finalise</a> </div> </div> </fieldset>";


const $83be1fed1e537956$var$config = {
    globalScope: "gardenBagsBookings",
    frontendUri: "https://bookings.gardenbagsbrisbane.com.au",
    apiUri: "https://api.gardenbagsbrisbane.com.au",
    reCaptchaKey: "6Ld4mS0UAAAAAPA8hS7l8hABCuYVMP7C39F06egU"
};
window[$83be1fed1e537956$var$config.globalScope] = window[$83be1fed1e537956$var$config.globalScope] || {};
var $83be1fed1e537956$export$2e2bcd8739ae039 = $83be1fed1e537956$var$config;


const $b0f905fd9230c6c6$var$initStep1 = async (params = {})=>{
    const serviceRequired = document.getElementById("service-required");
    const deliveryOption = document.getElementById("delivery-option");
    const oneOff = document.getElementById("one-off");
    const paymentOption = document.getElementById("payment-option");
    const binsBagsRow = document.getElementById("bins-bags-row");
    const numberBinsBags = document.getElementById("number-bins-bags");
    const additionalBag = document.getElementById("additional-bag");
    const additionalBagFee = document.getElementById("additional-bag-fee");
    const response = await fetch(`${(0, $83be1fed1e537956$export$2e2bcd8739ae039).frontendUri}/json/payment-options.json`, {
        headers: {
            "Content-Type": "application/json"
        }
    });
    const json = await response.json();
    window[(0, $83be1fed1e537956$export$2e2bcd8739ae039).globalScope].paymentOptions = json;
    serviceRequired.addEventListener("change", ()=>{
        if (serviceRequired.value === "Garden Bins") {
            if (deliveryOption.value === "one-off") {
                deliveryOption.value = "";
                deliveryOption.dispatchEvent(new Event("change"));
            }
            oneOff.setAttribute("disabled", "");
        } else oneOff.removeAttribute("disabled");
    });
    deliveryOption.addEventListener("change", ()=>{
        const paymentOptions = json[deliveryOption.value];
        if (paymentOptions) {
            const options = [
                ...Object.entries(paymentOptions)
            ];
            let html = '<option value="">Please Select</option>';
            for(let i = 0; i < options.length; i += 1){
                const [value, option] = options[i];
                html += `<option value="${value}">${option.name}</option>`;
            }
            paymentOption.innerHTML = html;
        }
        if (deliveryOption.value === "one-off") {
            binsBagsRow.style.display = "none";
            numberBinsBags.removeAttribute("required");
            numberBinsBags.value = "";
        } else {
            binsBagsRow.style.display = "flex";
            numberBinsBags.setAttribute("required", "");
        }
    });
    paymentOption.addEventListener("change", ()=>{
        const charge = json[deliveryOption.value] && json[deliveryOption.value][paymentOption.value] ? json[deliveryOption.value][paymentOption.value].amount : 0;
        if (charge > 0 && deliveryOption.value !== "one-off") {
            additionalBagFee.textContent = charge;
            additionalBag.style.display = "inline";
        } else additionalBag.style.display = "none";
    });
    const qsParams = params || {};
    if ([
        "bags",
        "bins"
    ].includes(qsParams.service)) {
        serviceRequired.value = `Garden B${qsParams.service.slice(1)}`;
        serviceRequired.dispatchEvent(new Event("change"));
    }
    if (qsParams.option) {
        deliveryOption.value = qsParams.option;
        deliveryOption.dispatchEvent(new Event("change"));
    }
    if (qsParams.bins) {
        paymentOption.value = qsParams.bins;
        paymentOption.dispatchEvent(new Event("change"));
    }
};
var $b0f905fd9230c6c6$export$2e2bcd8739ae039 = $b0f905fd9230c6c6$var$initStep1;



const $f55a14174fc6df06$var$initStep2 = async ()=>{
    const addressType = document.getElementById("address-type");
    const tenantDetailsRow = document.getElementById("tenant-details-row");
    const tenantName = document.getElementById("tenant-name");
    const tenantPhone = document.getElementById("tenant-phone");
    const businessNameRow = document.getElementById("business-name-row");
    const businessName = document.getElementById("business-name");
    const region = document.getElementById("region");
    const suburb = document.getElementById("suburb");
    const response = await fetch(`${(0, $83be1fed1e537956$export$2e2bcd8739ae039).frontendUri}/json/regions-suburbs.json`, {
        headers: {
            "Content-Type": "application/json"
        }
    });
    const json = await response.json();
    window[(0, $83be1fed1e537956$export$2e2bcd8739ae039).globalScope].regionsSuburbs = json;
    addressType.addEventListener("change", ()=>{
        if (addressType.value === "Investment Property") tenantDetailsRow.style.display = "flex";
        else {
            tenantDetailsRow.style.display = "none";
            tenantName.value = "";
            tenantPhone.value = "";
        }
        if (addressType.value === "Business Premises") businessNameRow.style.display = "flex";
        else {
            businessNameRow.style.display = "none";
            businessName.value = "";
        }
    });
    region.addEventListener("change", ()=>{
        const suburbs = json[region.value];
        if (suburbs) {
            let html = '<option value="">Please Select</option>';
            for(let i = 0; i < suburbs.length; i += 1){
                const value = suburbs[i];
                html += `<option value="${value}">${value}</option>`;
            }
            suburb.innerHTML = html;
        }
    });
};
var $f55a14174fc6df06$export$2e2bcd8739ae039 = $f55a14174fc6df06$var$initStep2;


const $5e904c1deae230e1$var$initStep3 = ()=>{
    const propertyTenanted = document.getElementById("property-tenanted");
    const landlordNameCell = document.getElementById("landlord-name-cell");
    const landlordName = document.getElementById("landlord-name");
    const agencyDetailsRow = document.getElementById("agency-details-row");
    const agencyName = document.getElementById("agency-name");
    const agencyPhone = document.getElementById("agency-phone");
    propertyTenanted.addEventListener("change", ()=>{
        if (propertyTenanted.value.substr(0, 14) === "Yes, I am the ") {
            landlordNameCell.style.display = "block";
            agencyDetailsRow.style.display = "flex";
            landlordName.setAttribute("required", "");
            agencyName.setAttribute("required", "");
            agencyPhone.setAttribute("required", "");
        } else {
            landlordNameCell.style.display = "none";
            agencyDetailsRow.style.display = "none";
            landlordName.removeAttribute("required");
            agencyName.removeAttribute("required");
            agencyPhone.removeAttribute("required");
            landlordName.value = "";
            agencyName.value = "";
            agencyPhone.value = "";
        }
    });
};
var $5e904c1deae230e1$export$2e2bcd8739ae039 = $5e904c1deae230e1$var$initStep3;





const $6b7e315bf13fc783$var$DROPIN_SRC = "https://js.braintreegateway.com/web/dropin/1.46.0/js/dropin.min.js";
const $6b7e315bf13fc783$var$loadScript = async (src)=>{
    return new Promise((resolve)=>{
        const script = document.createElement("script");
        script.async = true;
        script.defer = true;
        script.onload = ()=>{
            resolve();
        };
        document.head.appendChild(script);
        script.src = src;
    });
};
const $6b7e315bf13fc783$var$getClientToken = async ()=>{
    const response = await fetch(`${(0, $83be1fed1e537956$export$2e2bcd8739ae039).apiUri}/bookings/?get-token=true`, {
        headers: {
            Accept: "application/json"
        }
    });
    return response.json();
};
const $6b7e315bf13fc783$export$c564be2210231afb = async ()=>{
    if (window[(0, $83be1fed1e537956$export$2e2bcd8739ae039).globalScope].dropinInstance) return;
    const [token] = await Promise.all([
        $6b7e315bf13fc783$var$getClientToken(),
        $6b7e315bf13fc783$var$loadScript($6b7e315bf13fc783$var$DROPIN_SRC)
    ]);
    window[(0, $83be1fed1e537956$export$2e2bcd8739ae039).globalScope].dropinInstance = await window.braintree.dropin.create({
        authorization: token.data,
        container: "#card-dropin",
        card: {
            cardholderName: {
                required: true
            }
        }
    });
};
const $6b7e315bf13fc783$export$4faec9eaf4ce324e = async (submitForm, toggleButtons)=>{
    try {
        const { nonce: nonce } = await window[(0, $83be1fed1e537956$export$2e2bcd8739ae039).globalScope].dropinInstance.requestPaymentMethod();
        document.getElementById("card-nonce").value = nonce;
        submitForm();
    } catch (error) {
        // Drop-in shows what is missing or invalid in the card details
        toggleButtons(false);
    }
};
// a nonce can only be charged once, so a failed order needs the card entered again
const $6b7e315bf13fc783$export$15ed6e1e659ed9b4 = ()=>{
    document.getElementById("card-nonce").value = "";
    const { dropinInstance: dropinInstance } = window[(0, $83be1fed1e537956$export$2e2bcd8739ae039).globalScope];
    if (dropinInstance) dropinInstance.clearSelectedPaymentMethod();
};


const $f5eecdfaf23653be$export$60fc47fdd6a2e210 = (disable = true)=>{
    const form = document.getElementById("form");
    const buttons = form.querySelectorAll('a[data-current="4"]');
    const cog = document.getElementById("submit-cog");
    buttons.forEach((button)=>{
        if (disable) button.classList.add("disabled");
        else button.classList.remove("disabled");
    });
    if (disable) cog.classList.add("fa-spin");
    else cog.classList.remove("fa-spin");
};
const $f5eecdfaf23653be$var$disableForm = (form)=>{
    const paymentMethods = form.querySelectorAll('input[name="payment_method"]');
    const buttons = form.querySelectorAll('a[data-current="4"]');
    const cog = document.getElementById("submit-cog");
    paymentMethods.forEach((radio)=>radio.setAttribute("disabled", ""));
    buttons.forEach((button)=>{
        const { style: style } = button;
        style.display = "none";
    });
    cog.style.display = "none";
};
const $f5eecdfaf23653be$var$getFormValues = (form)=>{
    const fields = form.querySelectorAll("input, select, textarea");
    const formData = {};
    fields.forEach((field)=>{
        if (field.name !== "g-recaptcha-response" && field.name !== "" && (![
            "checkbox",
            "radio"
        ].includes(field.type) || field.checked === true)) formData[field.name] = field.value;
    });
    return formData;
};
const $f5eecdfaf23653be$var$executeReCaptcha = async ()=>{
    const successAlert = document.getElementById("success-alert");
    const errorAlert = document.getElementById("error-alert");
    successAlert.style.display = "none";
    errorAlert.style.display = "none";
    $f5eecdfaf23653be$export$60fc47fdd6a2e210();
    window.grecaptcha.execute();
};
const $f5eecdfaf23653be$var$postData = async (formData)=>{
    const response = await fetch(`${(0, $83be1fed1e537956$export$2e2bcd8739ae039).apiUri}/bookings/`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
    });
    return response.json();
};
const $f5eecdfaf23653be$var$showResult = (json)=>{
    const type = json.success ? "success" : "error";
    const alert = document.getElementById(`${type}-alert`);
    const message = document.getElementById(`${type}-message`);
    message.textContent = json.message;
    alert.style.display = "block";
    if (!json.success) (0, $6b7e315bf13fc783$export$15ed6e1e659ed9b4)();
};
const $f5eecdfaf23653be$export$e02251cfbe407ee6 = async ()=>{
    const form = document.getElementById("form");
    const formData = $f5eecdfaf23653be$var$getFormValues(form);
    if (formData.payment_method === "Credit Card" && !formData.nonce) {
        (0, $6b7e315bf13fc783$export$4faec9eaf4ce324e)($f5eecdfaf23653be$export$e02251cfbe407ee6, $f5eecdfaf23653be$export$60fc47fdd6a2e210);
        return;
    }
    const recaptchaToken = document.getElementById("recaptcha-token");
    if (recaptchaToken.value === "") {
        $f5eecdfaf23653be$var$executeReCaptcha();
        return;
    }
    const json = await $f5eecdfaf23653be$var$postData(formData);
    if (json.success) $f5eecdfaf23653be$var$disableForm(form);
    else {
        window.grecaptcha.reset();
        document.getElementById("recaptcha-token").value = "";
        $f5eecdfaf23653be$export$60fc47fdd6a2e210(false);
    }
    $f5eecdfaf23653be$var$showResult(json);
};



const $915ecaa40d61c3cc$var$updatePrice = (total)=>{
    document.getElementById("charge").value = total.toFixed(2);
    document.getElementById("total").value = total.toFixed(2);
    document.getElementById("info-total").textContent = total.toFixed(2);
};
const $915ecaa40d61c3cc$var$calculatePrice = ()=>{
    const deliveryOption = document.getElementById("delivery-option");
    const paymentOption = document.getElementById("payment-option");
    const numberBinsBags = document.getElementById("number-bins-bags");
    const { paymentOptions: paymentOptions } = window[(0, $83be1fed1e537956$export$2e2bcd8739ae039).globalScope];
    const charge = paymentOptions[deliveryOption.value] && paymentOptions[deliveryOption.value][paymentOption.value] ? paymentOptions[deliveryOption.value][paymentOption.value].amount : 0;
    const pickups = deliveryOption.value !== "one-off" && paymentOption.value > 0 ? +paymentOption.value : 1;
    const binsBags = numberBinsBags.value > 0 ? +numberBinsBags.value : 1;
    $915ecaa40d61c3cc$var$updatePrice(charge * pickups * binsBags);
};
const $915ecaa40d61c3cc$var$initStep4 = ()=>{
    $915ecaa40d61c3cc$var$calculatePrice();
    const paymentMethods = document.querySelectorAll('input[name="payment_method"]');
    const directDepositInfo = document.getElementById("direct-deposit-info");
    const cardDetails = document.getElementById("card-details");
    paymentMethods.forEach((radio)=>radio.addEventListener("change", ()=>{
            directDepositInfo.style.display = radio.value === "Direct Deposit" ? "block" : "none";
            cardDetails.style.display = radio.value === "Credit Card" ? "block" : "none";
            if (radio.value === "Credit Card") (0, $6b7e315bf13fc783$export$c564be2210231afb)();
            (0, $f5eecdfaf23653be$export$60fc47fdd6a2e210)(false);
        }));
};
var $915ecaa40d61c3cc$export$2e2bcd8739ae039 = $915ecaa40d61c3cc$var$initStep4;





const $e9426daf7e780159$var$onloadCallback = ()=>{
    window.grecaptcha.render("recaptcha", {
        sitekey: (0, $83be1fed1e537956$export$2e2bcd8739ae039).reCaptchaKey,
        size: "invisible",
        badge: "inline",
        callback: window.recaptchaVerified,
        "error-callback": window.recaptchaError,
        "expired-callback": window.recaptchaExpired
    });
};
const $e9426daf7e780159$var$verifiedCallback = (token)=>{
    const recaptchaToken = document.getElementById("recaptcha-token");
    recaptchaToken.value = token;
    (0, $f5eecdfaf23653be$export$e02251cfbe407ee6)();
};
const $e9426daf7e780159$var$errorCallback = ()=>{
    window.grecaptcha.reset();
    (0, $f5eecdfaf23653be$export$60fc47fdd6a2e210)(false);
};
const $e9426daf7e780159$var$expiredCallback = ()=>{
    const successAlert = document.getElementById("success-alert");
    const cog = document.getElementById("submit-cog");
    if (successAlert.style.display === "none" && !cog.classList.contains("fa-spin")) {
        window.grecaptcha.reset();
        (0, $f5eecdfaf23653be$export$60fc47fdd6a2e210)(false);
    }
};
const $e9426daf7e780159$export$6125b5139919eead = ()=>{
    window.recaptchaOnload = $e9426daf7e780159$var$onloadCallback;
    window.recaptchaVerified = $e9426daf7e780159$var$verifiedCallback;
    window.recaptchaError = $e9426daf7e780159$var$errorCallback;
    window.recaptchaExpired = $e9426daf7e780159$var$expiredCallback;
    const script = document.createElement("script");
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
    script.src = "https://www.google.com/recaptcha/api.js?onload=recaptchaOnload&render=explicit";
};


/* eslint-disable import/no-unresolved */ var $af06b07127c2fac7$exports = {};
$af06b07127c2fac7$exports = "<header id=\"header\"> <div class=\"container\" id=\"contact\"> <div class=\"row\"> <div class=\"col-sm-6\"> <img src=\"/ecoclear-garden-bags-logo.a816ac32.jpg\" alt=\"EcoClear Garden Bags logo\" width=\"235\" height=\"79\" class=\"img-fluid\" id=\"logo\"> </div> <address class=\"col-sm-6\"> <i class=\"fa-phone fas\"></i> <a href=\"tel:+61733433030\">07 3343 3030</a><br> <i class=\"fa-at fas\"></i> <a href=\"mailto:info@gardenbagsbrisbane.com.au\">info@gardenbagsbrisbane.com.au</a><br> <i class=\"fa-map-marker-alt fas\"></i> PO Box 6172, Fairfield Gardens, QLD 4103 </address> </div> </div> <div id=\"heading\"> <div class=\"container\"> <h1>Garden Bag Hire</h1> </div> </div> </header><main id=\"main\"></main><footer id=\"footer\"> <div class=\"container\"> © Copyright 2021 Garden Bags Brisbane. All Rights Reserved. </div> </footer>";


var $35e9450c60e709ee$exports = {};
$35e9450c60e709ee$exports = "<div class=\"container\"> <h1>Page Not Found</h1> </div>";


const $25b2a01fd18562a6$export$154c38a9894cf6d9 = (embed = false)=>{
    const existing = document.getElementById("main");
    if (existing) return existing;
    const app = document.getElementById("app");
    app.insertAdjacentHTML("afterbegin", (0, (/*@__PURE__*/$parcel$interopDefault($af06b07127c2fac7$exports))));
    if (embed) {
        document.getElementById("header").style.display = "none";
        document.getElementById("footer").style.display = "none";
        document.getElementById("main").classList.add("embedded");
    }
    return document.getElementById("main");
};
const $25b2a01fd18562a6$export$a33e918cb4258370 = ()=>{
    const main = $25b2a01fd18562a6$export$154c38a9894cf6d9();
    main.innerHTML = (0, (/*@__PURE__*/$parcel$interopDefault($35e9450c60e709ee$exports)));
};


const $320536e5e1bf81fc$var$formStepTemplates = {
    step1: (/*@__PURE__*/$parcel$interopDefault($310e8bee6db8d9d5$exports)),
    step2: (/*@__PURE__*/$parcel$interopDefault($cf51765c5de856cf$exports)),
    step3: (/*@__PURE__*/$parcel$interopDefault($0dadd6f7d90f42aa$exports)),
    step4: (/*@__PURE__*/$parcel$interopDefault($cf169d5cf45be00f$exports))
};
const $320536e5e1bf81fc$var$initFormSteps = {
    step1: (0, $b0f905fd9230c6c6$export$2e2bcd8739ae039),
    step2: (0, $f55a14174fc6df06$export$2e2bcd8739ae039),
    step3: (0, $5e904c1deae230e1$export$2e2bcd8739ae039),
    step4: (0, $915ecaa40d61c3cc$export$2e2bcd8739ae039)
};
const $320536e5e1bf81fc$var$enableValidation = ()=>{
    const form = document.getElementById("form");
    form.addEventListener("submit", (event)=>{
        if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
        }
        form.classList.add("was-validated");
    });
};
const $320536e5e1bf81fc$var$checkValidation = (step)=>{
    const fieldset = document.getElementById(`step-${step}`);
    fieldset.classList.add("was-validated");
    /* const fields = [...fieldset.querySelectorAll('input, select, textarea')];
	for (let i = 0; i < fields.length; i += 1) {
		fields[i].checkValidity();
	} */ return fieldset.querySelectorAll("input:invalid, select:invalid, textarea:invalid").length === 0;
};
const $320536e5e1bf81fc$var$clearValidation = (step)=>{
    const fieldset = document.getElementById(`step-${step}`);
    fieldset.classList.remove("was-validated");
};
const $320536e5e1bf81fc$export$80479f8d15f127c8 = (embed = false)=>{
    const existing = document.getElementById("steps");
    if (existing) return existing;
    const main = (0, $25b2a01fd18562a6$export$154c38a9894cf6d9)(embed);
    main.innerHTML = (0, (/*@__PURE__*/$parcel$interopDefault($fbc2b18346c73c7c$exports)));
    if (embed) document.getElementById("main-container").classList.replace("container", "container-fluid");
    $320536e5e1bf81fc$var$enableValidation();
    (0, $e9426daf7e780159$export$6125b5139919eead)();
    return document.getElementById("steps");
};
const $320536e5e1bf81fc$export$93a8248e85d9160b = async (step, params = {})=>{
    if (![
        1,
        2,
        3,
        4
    ].includes(step)) return;
    const embed = (params || {}).embed === "true";
    const steps = $320536e5e1bf81fc$export$80479f8d15f127c8(embed);
    const otherSteps = [
        ...steps.querySelectorAll(`fieldset:not(#step-${step})`)
    ];
    for(let i = 0; i < otherSteps.length; i += 1)otherSteps[i].style.display = "none";
    const existing = document.getElementById(`step-${step}`);
    if (existing) {
        existing.style.display = "block";
        if (step === 4) {
            const paymentMethod = document.querySelector('input[name="payment_method"]:checked');
            if (paymentMethod) paymentMethod.dispatchEvent(new Event("change"));
        }
        return;
    }
    steps.insertAdjacentHTML("beforeend", $320536e5e1bf81fc$var$formStepTemplates[`step${step}`]);
    $320536e5e1bf81fc$var$initFormSteps[`step${step}`](params);
};
const $320536e5e1bf81fc$export$6e55f347b1cf1f4e = (router)=>{
    const steps = $320536e5e1bf81fc$export$80479f8d15f127c8();
    const stepsData = steps.dataset;
    if (!stepsData.hasRouterListener) {
        stepsData.hasRouterListener = true;
        steps.addEventListener("click", (event)=>{
            const element = event.target;
            const elementData = element.dataset;
            if (elementData.step) {
                event.preventDefault();
                event.stopPropagation();
                if (element.classList.contains("disabled")) return;
                if (elementData.step === "prev") router.navigate(element.getAttribute("href"));
                else if ($320536e5e1bf81fc$var$checkValidation(elementData.current)) {
                    $320536e5e1bf81fc$var$clearValidation(elementData.current);
                    if (elementData.current === "4") {
                        (0, $f5eecdfaf23653be$export$60fc47fdd6a2e210)();
                        (0, $f5eecdfaf23653be$export$e02251cfbe407ee6)();
                    } else router.navigate(element.getAttribute("href"));
                }
            }
        });
    }
};



const $1fbe6d1664f64d6d$var$router = new (0, (/*@__PURE__*/$parcel$interopDefault($f04f93e6bce7a67b$exports)))("/");
$1fbe6d1664f64d6d$var$router.hooks({
    before (done, match) {
        if (match.url !== "" && !document.getElementById("step-1")) {
            $1fbe6d1664f64d6d$var$router.navigate("/", {
                historyAPIMethod: "replaceState",
                callHooks: false
            });
            done(false);
            return;
        }
        done();
    }
});
$1fbe6d1664f64d6d$var$router.on({
    "/": ({ params: params })=>{
        (0, $320536e5e1bf81fc$export$93a8248e85d9160b)(1, params).then((0, $320536e5e1bf81fc$export$6e55f347b1cf1f4e)($1fbe6d1664f64d6d$var$router));
    },
    "/step-2": ()=>{
        (0, $320536e5e1bf81fc$export$93a8248e85d9160b)(2);
    },
    "/step-3": ()=>{
        (0, $320536e5e1bf81fc$export$93a8248e85d9160b)(3);
    },
    "/step-4": ()=>{
        (0, $320536e5e1bf81fc$export$93a8248e85d9160b)(4);
    }
});
$1fbe6d1664f64d6d$var$router.notFound(()=>{
    (0, $25b2a01fd18562a6$export$a33e918cb4258370)();
});
var $1fbe6d1664f64d6d$export$2e2bcd8739ae039 = $1fbe6d1664f64d6d$var$router;


(0, $1fbe6d1664f64d6d$export$2e2bcd8739ae039).resolve();


//# sourceMappingURL=index.a239ff54.js.map
